// extracted by mini-css-extract-plugin
export var land = "index-module--land--D49qJ";
export var countdown = "index-module--countdown--kiMPJ";
export var block = "index-module--block--Ap3N1";
export var value = "index-module--value--hiu+P";
export var label = "index-module--label--VNyEj";